import { render, staticRenderFns } from "./savingStrategy.vue?vue&type=template&id=3b3239b8&scoped=true&"
import script from "./savingStrategy.vue?vue&type=script&lang=js&"
export * from "./savingStrategy.vue?vue&type=script&lang=js&"
import style0 from "./savingStrategy.vue?vue&type=style&index=0&id=3b3239b8&lang=less&scoped=true&"
import style1 from "./savingStrategy.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3239b8",
  null
  
)

export default component.exports